import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App'
import './assets/styles/styles.scss'
import './assets/styles/custom.scss'
import './App.scss';

ReactDOM.render(<App/>, document.getElementById('root'));